import React from 'react'
import { Typography, Card, Image } from 'antd'
import SimpleBackground from '@/components/SimpleBackground'

const { Title } = Typography

const UserSetRules = () => {
  return (
    <div className="m-auto h-full w-full">
      <SimpleBackground />
      <div className="m-auto w-[768px] max-w-full overflow-auto px-2 py-12 lg:px-6">
        <Image alt="" src="/manual/bg.png" preview={false} className="object-cover" />
        <Card bordered={false} className="w-full max-w-4xl bg-white shadow-lg lg:p-5">
          <Title className="text-center" level={1}>
            详解4：设定规则
          </Title>
          <div className="text-lg">
            <div className="my-4">
              <Image src="/manual/set_rules/1.png" alt="" />
            </div>
            <p>一、非复式比赛</p>
            <p>包括组队赛、单人赛、循环赛、团团转、超分赛、联赛、团体赛。</p>
            <p>（一）赛事设置</p>
            <p>点击比赛设置→赛事设置</p>
            <p>1、赛事基础</p>
            <p>比赛总轮数：定义比赛共打几轮。轮数随时可以增减，系统会按定义的轮数统计成绩。</p>
            <p>每轮计副数：定义每轮比赛打几副牌。</p>
            <p>每轮时间（分钟）：定义每轮比赛打几分钟。</p>
            <p>几分钟停止抓牌：定义剩余几分钟时，在计时器上提示停止抓牌。</p>
            <p>管理员列表：输入手机号，使用该手机号登录系统的用户就成为该赛事的管理员，拥有该赛事的管理权限。</p>
            <p>
              排名依据（按次序排名）：选择用于排名的条件，排名时按照所选条件的排列顺序依次进行对比。不同类型的比赛，排名条件也不同。已
              选中的条件，每个条件后面有个“×”，不需要某个条件或需要更改排列顺序时，点“×”取消已选条件，然后依次重新选择。
            </p>
            <p>
              团体列表：用
              Excel表格导入选手信息时，如果表格录入了团体信息，则所有团体会自动显示。如需添加团体，在此处输入团体名称并按回车键确定。团体名称定义后，可供修改队伍信息时选择使用。团体信息主要用于决定编排时本团体是否相遇，以及排定团体名次。
            </p>
            <p>
              注意：如果需要统计团体成绩，而导入时没有团体信息，则必须先在此处添加，然后通过修改队伍信息功能选择团体并保存。修改队伍信息时人工输入的团体名称，不会在此处显示，也不会用于团体成绩的统计。
            </p>
            <p>导出样例表用于导出团体信息的 Excel表格。</p>
            <p>导入团体信息用于导入按例表编辑好的团体信息。</p>
            <p>2、签到/记分设置</p>
            <p>选手签到和记分时使用。</p>
            <div className="my-4">
              <Image src="/manual/set_rules/2.png" alt="" />
            </div>
            <p>
              仅允许搜索手机号：勾选后，选手使用手机登录系统时，只允许输入手机号进行查询并登录；不勾选，则可以输入手机号或者姓名进行查询并登录。使用手机号登录，可解决姓名相重的问题。
            </p>
            <p>提示输入手机号：定义选手使用手机登录系统时，是否在姓名输入框内提示输入手机号。勾选后选手输入姓名时提示“输入姓名或手机”；未勾选则提示“输入姓名”。</p>
            <p>
              签到/记分必须登录：定义选手使用手机登录系统时，是否需要先登
              录个人灵缇账号。如果勾选了，则需要选手事先注册一个灵缇账号并登录；反之，则无需登录个人账号，可直接进入签到/记分界面。
            </p>
            <p>
              计分无视时间：和系统的比赛计时功能关联。勾选后，无论是否开始比赛计时，选手均可以记分。未勾选，则只有在本轮比赛开始计时后，选手才可以记分；本轮比赛时间结束后，停止选手记分。
            </p>
            <p>3、报名设置</p>
            <p>选手报名时的条件设置。</p>
            <div className="my-4">
              <Image src="/manual/set_rules/3.png" alt="" />
            </div>
            <p>允许团体为空：定义选手报名时，是否允许不填团体名称。</p>
            <p>允许微信公众号报名：定义是否允许选手通过灵缇互娱微信公众号进行报名。选手需先关注公众号才能报名。</p>
            <p>允许单人报名：定义是否允许选手单人报名。勾选后，在选手报名界面会出现切换为单人报名的选项，切换后即可进行单人报名。</p>
            <div className="my-4">
              <Image src="/manual/set_rules/4.png" alt="" />
            </div>
            <p>报名截止（打开此项即完全截止）：勾选后，报名截止。</p>
            <p>报名截止时间：选择报名的截止时间，到时间后报名截止。 通道报名上限(1 队 2 人),上限随 vip 等级提升：以队（2 人）为单位，定义每个账号可报名的上限数量。</p>
            <p>4、收费设置</p>
            <p>设置选手报名费。</p>
            <div className="my-4">
              <Image src="/manual/set_rules/5.png" alt="" />
            </div>
            <p>定义报名时是否缴纳报名费、附加费，默认为“0”，免费。 如果需要收费，选手缴纳费用会统一交到灵缇互娱公司账上，公司再 以对公转账方式转给应收方，公司收取5%手续费。</p>
            <p>5、保存和删除</p>
            <p>所有内容随时可以修改，录入或修改后点保存。</p>
            <p>如果该场赛事不再需要保留在系统中，点删除比赛。</p>
            <p>（二）基础信息</p>
            <p>点击比赛设置→基础信息</p>
            <div className="my-4">
              <Image src="/manual/set_rules/6.png" alt="" />
            </div>
            <p>比赛开始时间：用于记录比赛的开始时间。</p>
            <p>比赛名称：修改比赛的名称。</p>
            <p>报名链接：点复制链接，将链接复制后发送给别的用户，用户打开链接即可进入报名界面。</p>
            <p>投屏链接：点复制链接，将链接复制后发送给别的用户，用户打开链接即可看到投屏内容。</p>
            <p>裁判用链接：点复制链接，将链接复制后发送给裁判，裁判打开链接后进入专用界面，可查看全场比赛情况，也可选择任一桌次，对该桌记分进行管理。</p>
            <div className="my-4">
              <Image src="/manual/set_rules/7.png" alt="" />
            </div>
            <p>（三）赛事奖品</p>
            <p>点击比赛设置→赛事奖品</p>
            <div className="my-4">
              <Image src="/manual/set_rules/8.png" alt="" />
            </div>
            <p>1、设置每个奖项的数量。投屏时，可以在投屏控制中勾选获将名单，用于颁奖时只显示获奖队伍。</p>
            <p>2、开启团体排名：需要团体排名时，必须开启。开启后，左侧菜单 会出现团体排名，点击团体排名，可以查看团体的排名情况。</p>
            <p>3、统计前几名：团体赛时，定义取每个团体中前几名的成绩进行统计排名。</p>
            <p>（四）VIP专区</p>
            <p>点击比赛设置→VIP专区</p>
            <div className="my-4">
              <Image src="/manual/set_rules/9.png" alt="" />
            </div>
            <p>去除广告（投屏页面二维码）：定义投屏时，是否去除投屏页面上的灵缇互娱微信公众号二维码。</p>
            <p>是否私人赛（不在比赛列表中显示）：勾选后，比赛列表中不显示该赛事名称。</p>
            <p>是否测试赛：勾选后，所创建的比赛为测试赛，不占用比赛创建额度。</p>
            <p>是否为淘汰赛：勾选后为淘汰制，败方直接淘汰，不进入下一轮。</p>
            <p>需要双提交：勾选后，选手记分时，需要东西方和南北方都提交后成绩才有效。</p>
            <p>
              比赛结束：勾选后，无法对比赛进行编排和结算，选手无法扫码进入本场比赛。创建的赛事，如果一周时间未对赛事进行编排和结算操作，系统会默认比赛结束，如果需继续操作赛事，可人工取消该选项。
            </p>
            <p>允许选手自己操作弃权：定义选手记分时，是否可以自己操作弃权。仅提交后修改实时排名（若关闭则任意记分改动都会修改）：定义记分后对排名更新的影响。</p>
            <p>一码通界面是否展示分数：勾选后，选手扫描签到/积分二维码后，会显示自己的分数。</p>
            <p>本次比赛是否计入青岛系列天梯分：勾选后，比赛成绩记入青岛掼协会员积分系统进行排名。</p>
            <p>本次比赛是否计入天梯分：勾选后，比赛成绩记入灵缇互娱的会员积分系统进行排名。</p>
            <p>报名提示人数：定义选手报名时，在报名界面下方是否显示已报名的人数（队伍）。</p>
            <p>团团转规则：勾选后，规则文书中会显示团团转比赛的规则。</p>
            <p>是否加密：如果赛事有保密要求，相关信息不向外透露，勾选后，对名单导入、信息查询等进行操作时，需要输入对应秘钥。</p>
            <p>
              加密密钥：点击生成密钥可生成数字密钥，生成后请妥善保存。密钥生成一次即可，若重复生成密钥，则之前录入的队伍也将作废。
              遇到轮空得场分：定义轮空队伍的得分，用于计算成绩。
            </p>
            <p>关联赛事：选择多个赛事后，选中的赛事可共用任意一个赛事的二维码。</p>
            <p>报名提示：此处输入的信息，选手报名时，会显示在报名界面，起到提醒作用。</p>
            <p>临时 VIP（取最高值）：灵缇互娱内部管理员使用。</p>
            <p>规则文书：录入比赛规则，供投屏时使用。</p>
            <p>二、复式比赛</p>
            <p>包括四人队式开闭室复式赛、米切尔复式赛、瑞士偏差分复式赛。</p>
            <p>1、点击比赛设置→VIP 专区，会出现是否为 5 分制（关闭则为 6 分制）选项，用于定义记分方式。</p>
            <p>这里的计分制选择和复式设置中的打勾为 5 分制（关闭则为 6 分制）选项的功能一样，两处只选一处即可，若重复选择，系统默认以最后一次选择为准。</p>
            <div className="my-4">
              <Image src="/manual/set_rules/11.png" alt="" />
            </div>
            <p>2、创建复式赛后，左侧菜单会出现复式设置、复式派牌。</p>
            <p>点击复式设置→一键生成，可生成每轮每副的级牌和首领出牌者，记分时，会显示级牌，对应记分；不生成则记分时不显示级牌。</p>
            <div className="my-4">
              <Image src="/manual/set_rules/12.png" alt="" />
            </div>
            <p>这里的计分制选择和 VIP 专区中的选项一样，两处只选一处即可，若重复选择，系统默认以最后一次选择为准。</p>
            <p>点击复式设置→复式派牌，仅用于记录，对系统运行无影响。</p>
            <div className="my-4">
              <Image src="/manual/set_rules/13.png" alt="" />
            </div>
            <p>三、排名依据</p>
            <p>主要排名条件如下。</p>
            <p>场分：胜得 2 分，负不得分，平各得 1 分。</p>
            <p>胜轮次：获胜的轮次。胜方得 1 分，其他不得分。</p>
            <p>级差分：26 分制。平各得 13 分，每产生 1 个级差，胜分加 1 分，负方减 1 分。高于 13 个级差时，胜得 26 分，负得 0 分。</p>
            <p>升级数：任一方获得的升级数量。</p>
            <p>对手级差分：相遇所有对手的级差分之和，计算方法同级差分。</p>
            <p>对手场分：相遇所有对手的场分之和。</p>
            <p>轮高分：把每轮得分按降序排列后，进行依次比较，若有不同得分，则高分列前。</p>
            <p>团团转积分：每副牌获得的积分之和。</p>
            <p>复式积分：每副牌获得的积分之和。</p>
            <p>科学偏差分：科学偏差分=队伍得分-平均得分。平均得分指同方向所有队伍得分的平均分。</p>
            <p>科学场分：基于科学偏差分得出的场分。计分规则：偏差分大于 0，场分为 2；偏差分等于 0，场分为 1，偏差分小于 0，场分为 0。</p>
            <p>
              中位数偏差分：中位数偏差分=队伍得分-中位数得分。中位数得分指所有队伍得分排序中，排在中间那个队伍的得分，如果队伍是单数，就取中间队伍的得分；如果队伍是双数，就取中间 2
              个队伍得分的平均分。
            </p>
            <p>中位数场分：基于中位数偏差分，得出的场分。计分规则：偏差分大于 0，场分为 2；偏差分等于 0，场分为 1；偏差分小于 0，场分为 0。</p>
            <p>
              中位 5 段场分：更细化的中位数场分，将分数分布在五个等级中。基于队伍得分的分布区间计分：分布于 0-25%，场分为 0；分布于 25%-50%，场分为 0.5，得分为中位数，场分为
              1；分布于 50%-75%，场分为 1.5；分布于 75%-100%，场分为 2。
            </p>
          </div>
        </Card>
      </div>
    </div>
  )
}

Object.assign(UserSetRules as any, {
  title: '设定比赛规则 · 灵缇赛事系统使用手册',
  description: '灵缇赛事系统比赛设置详解:组队赛、单人赛、循环赛、团团转、超分赛、联赛、团体赛与复式赛的赛事基础、计分、排名依据等规则设置。',
})

export default UserSetRules
